import { render, staticRenderFns } from "./custom-form-field-editor.vue?vue&type=template&id=2cfa5ed3&scoped=true&"
import script from "./custom-form-field-editor.vue?vue&type=script&lang=js&"
export * from "./custom-form-field-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa5ed3",
  null
  
)

export default component.exports